import { Button, Typography } from '@breetometer/components';
import { BreadcrumbAngleIcon, CopyIcon } from 'BreetAssets';
import { ImageComponent } from 'BreetComponents';
import { copyToClipboard } from 'BreetHelpers';
import { useQRCode } from 'BreetHooks';

import type { IResolveTradeTopUpMinimum } from '../DialogResolveTrade.helpers';

const TopUpMinimum = ({
	minimumValue,
	assetSymbol,
	assetName,
	walletAddress,
	avatar,
	onExitModal,
	onBackLink,
}: IResolveTradeTopUpMinimum) => {
	const { qrCode } = useQRCode({ address: walletAddress });

	return (
		<div className='resolvetrade_topupminimum'>
			<div className='resolvetrade_header'>
				<BreadcrumbAngleIcon
					focusable
					className='resolvetrade_header_backlink cursor_pointer svg-dark'
					onClick={onBackLink}
				/>
				<Typography
					as='h1'
					className='color-neutral-50'
				>
					Top-up Minimum
				</Typography>
			</div>

			<div className='resolvetrade_topupminimum_body'>
				<Typography className='color-primary-50'>
					To resolve the flagged transaction, send at least{' '}
					<span className='color-tertiary-400'>
						{minimumValue} {assetSymbol}
					</span>{' '}
					to meet up with the minimum amount for this transaction. It'll resolve automatically.
				</Typography>
			</div>

			<div className='resolvetrade_topupminimum_wallet'>
				<div className='resolvetrade_topupminimum_wallet_info border-dark-navy'>
					<ImageComponent src={avatar} />
					<div className='resolvetrade_topupminimum_wallet_info_content'>
						<Typography
							as='h5'
							className='color-neutral-50'
						>
							{assetName}
						</Typography>

						<div className='resolvetrade_topupminimum_wallet_info_address'>
							<Typography className='color-primary-50'>1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa</Typography>
							<CopyIcon
								variant='negative'
								className='cursor_pointer svg-dark'
								focusable
								onClick={copyToClipboard('1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa', 'Wallet Address copied')}
							/>
						</div>
					</div>
				</div>
				<div className='resolvetrade_topupminimum_wallet_qr border-dark-navy'>
					<ImageComponent src={qrCode} />
				</div>
			</div>

			<div className='resolvetrade_topupminimum_cta'>
				<Button
					label='Done'
					variant='primary'
					type='button'
					onClick={onExitModal}
				/>
			</div>
		</div>
	);
};

export default TopUpMinimum;
